export default __webpack_public_path__ + "9c4f95b9398348dfe7956c4a0f9c9e54.ttf";